var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { boundMethod } from 'autobind-decorator';
import { HighlightType } from 'flow-builder/types/node';
import { NodeMoveType } from '../../hooks/node/useMove/useMove';
import { HighlightMatch } from '../../hooks/useHighlight';
export const getIsInBounds = (pageX, pageY, { x: boundsX, y: boundsY }) => boundsX[0] < pageX &&
    boundsX[1] > pageX &&
    boundsY[0] < pageY &&
    boundsY[1] > pageY;
const NIL_MOVEMENT = { x: 0, y: 0 };
export class DragListener {
    constructor(props) {
        this.props = props;
        this.state = {
            isDragging: false,
            lastEvent: null,
            position: { x: 0, y: 0 },
            nodesToDrag: [],
        };
    }
    addListeners() {
        const { container } = this.props;
        container.on('mousedown', this.onMouseDown);
    }
    removeListeners() {
        const { container } = this.props;
        container.off('mousedown');
        window.removeEventListener('mouseup', this.onMouseUp);
        window.removeEventListener('mousemove', this.onMouseMove);
    }
    onMouseDown(_) {
        const { node: { id }, editorContext, } = this.props;
        const { state: { highlightState }, } = editorContext;
        const { viewport } = editorContext.view;
        if (!viewport) {
            return;
        }
        this.state.isDragging = true;
        const highlightNode = highlightState.nodes[id];
        if (highlightNode &&
            highlightNode.match !== HighlightMatch.Connection &&
            highlightState.type === HighlightType.INFO) {
            this.state.nodesToDrag = Object.keys(highlightState.nodes).filter((id) => highlightState.nodes[id].match === HighlightMatch.Node ||
                highlightState.nodes[id].match === HighlightMatch.Both);
        }
        else {
            this.state.nodesToDrag = [id];
        }
        viewport.plugins.pause('drag');
        window.addEventListener('mouseup', this.onMouseUp);
        window.addEventListener('mousemove', this.onMouseMove);
    }
    onMouseUp(event) {
        const { onDragEnd, editorContext } = this.props;
        const { lastEvent } = this.state;
        const { viewport } = editorContext.view;
        if (!viewport) {
            return;
        }
        if (lastEvent) {
            this.emitDragEvent(NIL_MOVEMENT, NodeMoveType.End);
            onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(event);
        }
        this.state.isDragging = false;
        this.state.lastEvent = null;
        this.state.position.x = 0;
        this.state.position.y = 0;
        this.state.nodesToDrag = [];
        window.removeEventListener('mouseup', this.onMouseUp);
        window.removeEventListener('mousemove', this.onMouseMove);
        viewport.plugins.resume('drag');
    }
    onMouseMove(event) {
        const { onDragStart, onDragMove, editorContext } = this.props;
        const { viewport } = editorContext.view;
        const { pageX, pageY } = event;
        if (!viewport || !this.state.isDragging) {
            return;
        }
        if (!this.state.lastEvent) {
            onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart(event);
            this.state.position.x = event.pageX;
            this.state.position.y = event.pageY;
            this.emitDragEvent(NIL_MOVEMENT, NodeMoveType.Start);
        }
        event.stopPropagation();
        this.state.lastEvent = event;
        const { position } = this.state;
        const scale = viewport.scale.x;
        const movement = {
            x: (pageX - position.x) / scale,
            y: (pageY - position.y) / scale,
        };
        this.state.position.x = pageX;
        this.state.position.y = pageY;
        this.emitDragEvent(movement, NodeMoveType.Drag);
        onDragMove === null || onDragMove === void 0 ? void 0 : onDragMove(event);
    }
    emitDragEvent(movement, type) {
        const { nodesToDrag } = this.state;
        const { editorContext } = this.props;
        const { handlers: { node: { onMove }, }, } = editorContext;
        const { viewport, cull } = editorContext.view;
        onMove({
            nodes: nodesToDrag,
            movement,
            type,
        });
        if (nodesToDrag.length <= 1 || !viewport || !cull) {
            return;
        }
        const bounds = viewport.getVisibleBounds();
        cull.cull(bounds);
        viewport.dirty = false;
    }
}
__decorate([
    boundMethod
], DragListener.prototype, "onMouseDown", null);
__decorate([
    boundMethod
], DragListener.prototype, "onMouseUp", null);
__decorate([
    boundMethod
], DragListener.prototype, "onMouseMove", null);
